import { useEffect, useState } from 'react';
import IconPeople from '../components/IconPeople';
import IconServers from '../components/IconServers';
import Page from '../components/Page';
import { useAppStore } from '../stores/useAppStore';
import { useNavigate, useParams } from 'react-router-dom';
import { AnimatePresence, motion } from 'motion/react';
import Button from '../components/Button';
import IconArrow from '../components/IconArrow';
import CurvedTextWithBackground from '../components/CurvedTextWithBackground';

const Rectangle = ({children, className = '', mode, ...props}) => (
    <div
        {...props}
        className={`
        ${className}
        border-3u border-[#1F335B] rounded-32u
        w-full
        relative
        ${mode === 'v' &&
            `before:left-[-0.15625rem] before:top-1/2 before:-translate-x-1/2
            before:contents[""]
        before:absolute
        before:w-22u
        before:h-22u
        before:rounded-full
        before:-translate-y-1/2
        before:bg-[#1F335B]`
        }
        ${mode === 'v' ?
            'px-[6.375rem] pt-[4.125rem] pb-[3.5rem] after:contents[""] after:absolute after:w-[50.5rem] after:h-3u after:left-[-0.15625rem] after:top-[calc(50%-0.15625rem)] after:-translate-x-[100%] after:bg-[#1F335B] after:-z-10' :
            'px-[3.875rem] py-[4.75rem]'}
        `}>
        {children}
    </div>
);

const Header = ({children, item, ...props}) => (
    <div className='absolute left-1/2 -translate-x-1/2 top-445u w-[50%] text-center' {...props}>
        <div className='font-light text-52u leading-60u'>{item.header}</div>
        {item.subheader &&
        <div className='font-light text-42u leading-none mt-43u text-[#E2E2E2]'>{item.subheader}</div>
        }
    </div>
);

const MotionRectangle = motion.create(Rectangle);
const MotionHeader = motion.create(Header);

function PageOutcomeEnterpriseSubpages() {
  const section = 'outcomes_for_enterprise';
  const { content, menuItems } = useAppStore();
  const [index, setIndex] = useState(0);
  const [lastIndex, setlastIndex] = useState(0);
  const { key } = useParams();
  const navigate = useNavigate();
  const keys = Object.keys(content[section].items);

  useEffect(() => {
    const newIndex = keys.findIndex((item) => item === key);
    setIndex(newIndex);
  }, [key]);

  const handleClick = (amount) => {
    setlastIndex(index);
    if (amount === -1 && index === 0) {
        navigate(`/${section}`);
        return;
    }
    const newIndex = index + amount;
    setIndex(newIndex);
    navigate(`/${section}/${menuItems[2].children[newIndex].key}`);
  };

  return (
    <Page className="pr-[19.625rem] pt-725u relative" paddingLeftCollapsed='18.125rem' paddingLeft='18.125rem'>
        <div className='absolute top-257u left-1/2 text-100u font-extralight -translate-x-1/2 z-30'>Outcomes for enterprise</div>
        <AnimatePresence mode="wait">
            <MotionHeader
                initial={{opacity:0}}
                animate={{opacity:1}}
                exit={{opacity:0}}
                item={content[section].items[key]}
                key={`header_${key}`}
            />
        </AnimatePresence>
        <div className='flex relative'>
            <motion.div
                initial={{width: key === menuItems[2].children[2].key ? "96%" : "70rem"}}
                animate={{width: key === menuItems[2].children[2].key ? "96%" : "70rem"}}
                transition={{duration:0.5, delay: 0.3}}
                className='
                relative
                h-[70rem]'>
                <div className='
                absolute
                w-full h-full
                rounded-full bg-gradient-animated blur-md'></div>
                <div className='
                absolute
                w-full h-full
                rounded-full bg-gradient-animated'></div>
                <div className='
                absolute
                inset-[0.375rem]
                bg-navy
                rounded-full'></div>
                <div className='
                absolute
                inset-[3.875rem]
                border-3u border-[#C7C8D3]/20
                rounded-full
                flex
                flex-col
                px-[20.625rem] pb-[7.25rem]
                '
                >
                    <AnimatePresence>
                        {key !== menuItems[2].children[2].key ? (
                            <motion.div
                                key='curved_text_1'
                                className='absolute h-full left-0 top-0'
                                initial={{opacity: 0, rotate: 20}}
                                animate={{opacity: 1, rotate: 0, transition:{duration: 0.5, delay: 0.5}}}
                                exit={{opacity: 0, rotate: 20, transition:{duration: 0.5}}}
                            >
                                <CurvedTextWithBackground
                                    backgroundColor='#061933'
                                    arcDirection="inside"
                                    startAngle={200}
                                    textSize={18}
                                    strokeWidth={24}
                                    text={menuItems[2].children[2].title}
                                    radius={247}
                                    lengthAdjustment={0.85}
                                    dyAdjustment={-0}
                                />
                            </motion.div>
                        ) :
                            <>
                            <motion.div
                                key='curved_text_2'
                                className='absolute h-full left-0 top-0'
                                initial={{opacity: 0, rotate: -20}}
                                animate={{opacity: 1, rotate: 0, transition:{duration: 0.5, delay: 0.5}}}
                                exit={{opacity: 0, rotate: -20, transition:{duration: 0.5}}}
                                >
                                <CurvedTextWithBackground
                                    backgroundColor='#061933'
                                    arcDirection="outside"
                                    startAngle={290}
                                    textSize={18}
                                    strokeWidth={24}
                                    text={menuItems[2].children[0].title}
                                    radius={247}
                                    lengthAdjustment={0.90}
                                    dyAdjustment={-0}
                                />
                            </motion.div>
                            <motion.div
                                key='curved_text_3'
                                className='absolute h-full right-0'
                                initial={{opacity: 0, rotate: -20}}
                                animate={{opacity: 1, rotate: 0, transition:{duration: 0.5, delay: 0.5}}}
                                exit={{opacity: 0, rotate: -20, transition:{duration: 0.5}}}
                            >
                                <CurvedTextWithBackground
                                    backgroundColor='#061933'
                                    arcDirection="inside"
                                    startAngle={165}
                                    textSize={18}
                                    strokeWidth={24}
                                    text={menuItems[2].children[1].title}
                                    radius={247}
                                    lengthAdjustment={0.95}
                                    dyAdjustment={-0}
                                />
                            </motion.div>
                            <motion.div
                                className='h-[18.5rem] flex items-center justify-center text-72u font-light'
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0, transition:{
                                    duration: 0.5,
                                    delay: 0.8
                                } }}
                                exit={{ opacity: 0, y: 20, transition:{
                                    duration: 0.2,
                                    delay: 0.1
                                } }}
                            >
                                <div>{ menuItems[2].children[2].title}</div>
                            </motion.div>
                            
                            <div className='flex gap-[3.8125rem]'>
                            {content[section].items[key].items.map((item, i) => (
                            <MotionRectangle
                                mode="h"
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0, transition:{
                                    duration: 0.5,
                                    delay: 1 + (0.1 * i)
                                } }}
                                exit={{ opacity: 0, y: 20, transition:{
                                    duration: 0.2,
                                    delay: 0.1 * i
                                } }}
                                
                                key={`${key}_${i}`}
                                >
                                <h1 className='font-light text-[3rem] leading-none mb-[2.1rem]'>{item.title}</h1>
                                <p className='font-light text-[2rem] leading-[3.375rem]'>{item.description}</p>
                            </MotionRectangle>  
                            ))}
                            </div>
                            </>}
                    </AnimatePresence>  
                </div>
                <IconServers
                    className='absolute left-0 top-1/2'
                    isOpen={key !== menuItems[2].children[1].key}
                    hideText={key === menuItems[2].children[2].key}
                    delay={lastIndex === 2 ? 0.6 : 0}
                    labelPos='r'
                />
                <IconPeople
                    className='absolute left-[100%] top-1/2'
                    isOpen={key !== menuItems[2].children[0].key}
                    hideText={key === menuItems[2].children[2].key}
                    delay={lastIndex === 2 ? 0.6 : 0}
                    labelPos='l'
                />
            </motion.div>
        
            <div className='relative flex-1'>
                <div className='
                    absolute top-1/2 -translate-y-1/2
                    -z-10
                flex-1 flex flex-col pl-[17.875rem] justify-center gap-[2.375rem]'>
                    <AnimatePresence mode="wait">
                    {(key === menuItems[2].children[0].key || key === menuItems[2].children[1].key) && content[section].items[key].items.map((item, i) => (
                    <MotionRectangle
                        mode="v"
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0, transition:{
                            duration: 0.5,
                            delay: (lastIndex === 2 ? 1 : 0) + 0.1 * i
                        } }}
                        exit={{ opacity: 0, x: -20, transition:{
                            duration: 0.2,
                            delay: 0.1 * i
                        } }}
                        
                        key={`${key}_${i}`}
                        >
                        <h1 className='font-light text-49u leading-none mb-6u'>{item.title}</h1>
                        <p className='font-light text-32u leading-48u'>{item.description}</p>
                    </MotionRectangle>  
                    ))}    
                    </AnimatePresence>         
                </div>
            </div>
      </div>
      

    <div className="
        absolute right-[6.375rem] top-[72.5rem]
        flex flex-col gap-[1.5rem]">
        <Button
            onClick={() => handleClick(-1)}
            className='w-[9rem] h-[9rem] click-effect py-[2.75rem] px-[3rem] justify-center'
        >
            <IconArrow className="w-[1.375rem] h-auto transform -scale-x-100" />
        </Button>
        <Button
            onClick={() => handleClick(1)}
            disabled={index === keys.length - 1}
            className={`w-[9rem] h-[9rem] click-effect py-[2.75rem] px-[3rem] justify-center
            ${
                index === keys.length - 1
                    ? 'opacity-50'
                    : ''
            }
            `}
        >
            <IconArrow className="w-[1.375rem] h-auto" />
        </Button>
      </div>
    
    </Page>
  );
}

export default PageOutcomeEnterpriseSubpages;